import { applyFallbackColorSettings, applyFallbackIds } from '../helpers/settingsReducerHelpers';

const initialState = {
  settings: {
    widgets: [],
    settings: {},
  },
  error: null,
  loaded: false,
};

function settingsReducer(state = initialState, action) {
  if (action.type === 'SETTINGS_UPDATE') {
    const settingsNoFallback = {
      ...state.settings,
      ...action.data,
    };

    const settings = {
      ...settingsNoFallback,
      settings: applyFallbackColorSettings(settingsNoFallback.settings),
      widgets: applyFallbackIds(settingsNoFallback.widgets),
    };

    return {
      ...state,
      settings,
      error: null,
      loaded: true,
    };
  }

  if (action.type === 'SETTINGS_ERROR') {
    return {
      ...state,
      error: action.error,
    };
  }

  return state;
}

export default settingsReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/settings.js